import { makeStyles } from "@material-ui/core";

export const callbackPageStyles = makeStyles({
    spinner: {
        position: "absolute",
        top: "50%",
        left: "calc(50% + 100px)",
        zIndex: "100",
    },
    errorContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        gap: "1rem",
    },
});
